const colors = {
  background: '#1e1b16',

  input_color: '#c1b994',
  input_border_color: '#232129',
  input_border_color_onfocus: '#b37400',
  input_text_color: '#232129',
  input_placeholder_color: '#666360',
  input_icon_color: '#666360',

  button_color: '#805300',
  button_text_color: '#fff',

  navbar_color: '#c1b994',

  text_color: '#665e48',
  frame_color: '#b37400',
  span_error_color: '#c53030',
  error_color: '#c53030',

    frame_info: '#fff',
    frame_dede: '#232129',


  sections_plans: {
    background: '#1e1c20',
    title: '#fff',

    button: '#ef7d46',
    button_text: '#1a181b',
    button_hover: '#fff',

    price: '#ef7d46',
    price_background: '#1a181b',
    price_hover: '#fff',
    price_background_before: '#141315',
    price_period: '#2a272c',

    description: '#555357',
    plan_info: '#6a6563',
  },
};

export default colors;
